import { Transition, Overlay, BoxProps } from '@mantine/core';
import { useUnit } from 'effector-react';
import { cashierLayoutModel } from '../../model';

export const CashierLayoutOverlay = ({ ...props }: BoxProps) => {
	const [modalsOpened, closeModals] = useUnit([
		cashierLayoutModel.$modalsOpened,
		cashierLayoutModel.closeModals,
	]);

	return (
		<Transition mounted={modalsOpened}>
			{(styles) => (
				<Overlay
					zIndex={100}
					style={styles}
					onClick={closeModals}
					{...props}
				/>
			)}
		</Transition>
	);
};
